import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../types/types'

export const SvgSettings = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<path
				fill="#4A4A4A"
				d="M4.114 13.885a8.448 8.448 0 010-2.77c.937.022 1.778-.427 2.105-1.216.327-.79.05-1.703-.629-2.348a8.449 8.449 0 011.96-1.96c.646.678 1.558.956 2.349.628.79-.327 1.238-1.169 1.215-2.105a8.449 8.449 0 012.772 0c-.023.937.426 1.778 1.215 2.105.79.328 1.703.05 2.348-.628a8.45 8.45 0 011.96 1.96c-.678.645-.956 1.558-.628 2.348.327.79 1.169 1.238 2.105 1.215a8.444 8.444 0 010 2.772c-.937-.023-1.778.426-2.105 1.215-.328.79-.05 1.703.629 2.348a8.447 8.447 0 01-1.96 1.96c-.646-.678-1.559-.956-2.349-.628-.79.327-1.238 1.169-1.215 2.105a8.444 8.444 0 01-2.772 0c.023-.937-.426-1.778-1.215-2.105-.79-.328-1.703-.05-2.348.629a8.448 8.448 0 01-1.96-1.96c.678-.646.955-1.559.628-2.349-.327-.79-1.17-1.239-2.105-1.216zM12.5 15c.676 0 1.325-.22 1.803-.697a2.55 2.55 0 000-3.606C13.824 10.22 13.176 10 12.5 10c-.676 0-1.325.22-1.803.697a2.55 2.55 0 000 3.606c.478.478 1.127.697 1.803.697z"
			></path>
			<path
				fill="url(#paint0_linear_13382_131572)"
				fillRule="evenodd"
				d="M4.114 13.885a8.448 8.448 0 010-2.77c.937.022 1.778-.427 2.105-1.216.327-.79.05-1.703-.629-2.348a8.449 8.449 0 011.96-1.96c.646.678 1.558.956 2.349.628.79-.327 1.238-1.169 1.215-2.105A8.45 8.45 0 0112.5 4v6a2.5 2.5 0 000 5v6a8.45 8.45 0 01-1.386-.114c.023-.937-.426-1.778-1.215-2.105-.79-.328-1.703-.05-2.348.629a8.448 8.448 0 01-1.96-1.96c.678-.646.955-1.559.628-2.349-.327-.79-1.17-1.239-2.105-1.216z"
				clipRule="evenodd"
			></path>
			<defs>
				<linearGradient
					id="paint0_linear_13382_131572"
					x1="3.575"
					x2="3.575"
					y1="21.944"
					y2="3.056"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#568DFE"></stop>
					<stop offset="1" stopColor="#E4EDFC"></stop>
				</linearGradient>
			</defs>
		</IconTemplateIPortIcon>
	)
}
